// extracted by mini-css-extract-plugin
export default {"scrollbar":"BFpZQa0eZo2tpJYKk0Eh","container":"RvYwq4WD4yPDchuW7bYS","scrollbarSlider":"yzsNdsUMBMUAnX_niMDA"};